var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"3"}},[_c('b-card',[_c('h3',[_vm._v(_vm._s(_vm.count.tableName.slice(_vm.count.tableName.indexOf('.') + 1)))]),_vm._v("\n    "+_vm._s(_vm.count.recordCount.toLocaleString())+" Records\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }